module.exports = __webpack_public_path__ + "static/media/img-company-success.30737605.png";